var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgChevronUp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "0 0 20 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.700373 11.3217C-0.233459 10.4174 -0.233459 8.95117 0.700373 8.04682L8.30922 0.67826C9.24306 -0.226084 10.7571 -0.226085 11.6909 0.678259C12.6248 1.5826 12.6248 3.04883 11.6909 3.95318L4.08208 11.3217C3.14825 12.2261 1.63421 12.2261 0.700373 11.3217Z",
    fill: "#8B8E99"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30922 0.67826C9.24306 -0.226084 10.7571 -0.226085 11.6909 0.678259L19.2996 8.0457C20.2335 8.95004 20.2335 10.4163 19.2996 11.3206C18.3658 12.225 16.8517 12.225 15.9179 11.3206L8.30907 3.95205C7.37524 3.04771 7.37539 1.5826 8.30922 0.67826Z",
    fill: "#8B8E99"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronUp);
export default __webpack_public_path__ + "static/media/chevron-up.cba8e1a5f682da753b660ab94001bf9e.svg";
export { ForwardRef as ReactComponent };